import queryString from 'qs';
import moment from 'moment';

export const getTotalRequestReschedulePayload = (filters) => {
  const queries = {
    yearMonth: moment().format('YYYY-MM'),
  };

  return queryString.stringify(queries, { skipEmptyString: true });
};

export default getTotalRequestReschedulePayload;
